import styled from 'styled-components';

const StyledDropzone = styled.div`
  padding: 1rem;
  cursor: pointer;
`;

export default StyledDropzone;
